import React from 'react';
import MobileTTSRequestsContainer from '@src/containers/MobileTTSRequests';

const MobileTTSRequests = () => <MobileTTSRequestsContainer />;

export default MobileTTSRequests;
